const FORIO_API_URL = 'https://api.forio.com/v2/run/processim-labs/laneslinger'

export { FORIO_API_URL }
